import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from '@reduxjs/toolkit';
import I18njs from 'i18n-js';

import Button from 'carbon-react/lib/components/button';
import Loader from 'carbon-react/lib/components/loader';
import Message from 'carbon-react/lib/components/message';
import Textbox from 'carbon-react/lib/components/textbox';

import Translate from '../../components/Translate/Translate';

import { checkPasswordComplexity } from '../../helpers/validations';

import * as user from '../../redux/User/actions';
import toastr from '../../helpers/toastr';

const ResetPassword = ({ history, match, resetPassword, user, validateResetToken }) => {
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  useEffect(() => {
    validateResetToken({ resetToken: match.params.resetToken });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = () => {
    setError('');
    if (password !== passwordConfirm) {
      setError(I18njs.t('reset.NoMatch'));
      return;
    }
    if (checkPasswordComplexity(password)) {
      const data = {
        password,
      };
      resetPassword({
        data,
        resetToken: match.params.resetToken,
      });
      history.push('/');
      toastr.success(I18njs.t('reset.ResetSuccess'));
    } else {
      setError(I18njs.t('settings.security.badPassword'));
    }
  };

  if (user.error)
    return (
      <div className="register" style={{ flexDirection: 'column' }}>
        <p>
          <Translate scope="reset.InviteError" />
        </p>
        <p>{JSON.stringify(user.error.message)}</p>
      </div>
    );

  return (
    <div className="reset-password">
      <div className="card">
        <div className="title">
          <Translate scope="reset.ResetPassword" />
        </div>
        {!user.token ? (
          <>
            <div className="password-wrapper">
              <Textbox
                autoComplete="new-password"
                label={I18njs.t('reset.NewPassword')}
                name="password"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                type={showPassword ? 'text' : 'password'}
                value={password}
              />
              <Button buttonType="tertiary" className="show-hide-button" onClick={() => setShowPassword(!showPassword)} size="small">
                {showPassword ? <Translate scope="reset.HIDE" /> : <Translate scope="reset.SHOW" />}
              </Button>
            </div>
            <div className="password-wrapper">
              <Textbox
                autoComplete="new-password-confirm"
                label={I18njs.t('reset.ConfirmNewPassword')}
                name="password-confirm"
                onChange={(e) => setPasswordConfirm(e.target.value)}
                type={showPasswordConfirm ? 'text' : 'password'}
                value={passwordConfirm}
              />
              <Button
                buttonType="tertiary"
                className="show-hide-button"
                onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                size="small"
              >
                {showPasswordConfirm ? <Translate scope="reset.HIDE" /> : <Translate scope="reset.SHOW" />}
              </Button>
            </div>
          </>
        ) : (
          <>
            <Translate scope="reset.SuccessMessage" />
          </>
        )}
        {!!error && (
          <div className="error-wrapper">
            <Message variant="error">{error}</Message>
          </div>
        )}
        {!!user.token ? (
          <Button buttonType="primary" className="save-button" onClick={() => history.push('/timesheets')}>
            <Translate scope="reset.Login" />
          </Button>
        ) : (
          <Button buttonType="primary" className="save-button" onClick={save}>
            {user.loading || user.saving ? <Loader isInsideButton /> : <Translate scope="reset.Save" />}
          </Button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => {
  const _user = bindActionCreators(user, dispatch);
  return {
    resetPassword: _user.resetPasswordRequest,
    validateResetToken: _user.validateResetTokenRequest,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetPassword));
